import { client } from '@/honoClient';

export const getSelfUserInfo = async () => {
  const res = await client.user.self.$get();
  if (res.status !== 200) {
    throw new Error('Failed to get user');
  }
  const data = await res.json();

  return data;
};

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Remove data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

type PictureContentType =
  | 'image/jpeg'
  | 'image/jpg'
  | 'image/png'
  | 'image/gif'
  | 'image/webp'
  | 'image/svg+xml';

export const updateSelfUserInfo = async (data: {
  name?: string | null;
  picture?: File;
}) => {
  const json: {
    name?: string;
    picture?: { data: string; contentType: PictureContentType };
  } = {};

  if (data.name !== undefined && data.name !== null) {
    json.name = data.name;
  }
  if (data.picture !== undefined) {
    const base64Data = await fileToBase64(data.picture);
    json.picture = {
      data: base64Data,
      contentType: data.picture.type as PictureContentType,
    };
  }

  const res = await client.user.self.$put({ json });
  if (res.status !== 200) {
    throw new Error('Failed to update user');
  }
  return await res.json();
};
